import {
    ApiHandler,
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import { DocumentSearchDetailsModel, DocumentSearchParameters, getDocumentSearchList } from "@us/Services/DocumentSearch/DocumentSearchService";

type HandlerType = ApiHandler<DocumentSearchParameters, DocumentSearchDetailsModel>;

export const DispatchBeginDocumentSearchData: HandlerType = (props:any) => {
    props.dispatch({
        type: "Custom/DocumentSearchData/BeginLoadDocumentSearchData",
        result: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = (props:any) => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async (props:any) => {
    props.apiResult = await getDocumentSearchList(props.apiParameter);
};

export const DispatchCompleteDocumentSearchData: HandlerType = (props:any) => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/DocumentSearchData/CompletedLoadDocumentSearchData",
        result: props.apiResult,
    });
};

export const chain = [
    DispatchBeginDocumentSearchData,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteDocumentSearchData,
];

const documentSearchHandler = createHandlerChainRunner(chain, "DocumentSearchHandler");
export default documentSearchHandler;